import React, { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { httpGet } from "../../../../utils/api.utils";
import { CATALOGUE_TABLE_HEADERS } from "../../../../utils/constant.utils";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { DataTable } from "../../../common/table/data-table/data-table-component";
import CatalogueDetails from "./detail/catalogue-details.component";
export class Catalog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            totalEntries: 0,
            catalogueDataItem: [],
            requestDetails: false,
        }
    }
    componentDidMount() {
        this.getCatalogueDetails(this.state.pageNumber);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.pageNumber !== this.state.pageNumber) {
            this.setState({ requestDetails: false })
            this.getCatalogueDetails(this.state.pageNumber);
        }

    }
    updatePageNumber = (page) => {
        this.setState({ pageNumber: page })
    }
    getCatalogueDetails = async (pageNumber) => {
        this.setState({ activePage: pageNumber });
        var that = this;
        const dealName = window.sessionStorage.getItem('DealName')
        const getCatalogueData = await httpGet(`finance/${dealName}/catalogue/${pageNumber}`)
       /* const countContracts = await httpGet(`finance/${dealName}/contractCount?searchVal=null&filterType=Contract Name&pageNumber=${pageNumber}`)*/
        var userID = window.sessionStorage.getItem("UserID");
        const newCatalogueData = getCatalogueData?.map((item) => (
            {
                VendorName: item.VendorName,
                AccountNumber: item.AccountNumber,
                PricePlan: item.PricePlan,
                PriceComponent: item.PriceComponent,
                Description: item.Description,
                Cost: item.Cost,
                Currency: item.Currency,
                PlanStatus: item.PlanStatus,
            }))

        this.setState({ catalogueDataItem: [...newCatalogueData] });
        if (this.state.catalogueDataItem.length > 0) {
            this.setState({ requestDetails: true, totalEntries: 0 })
        }
    }
    getData=(value)=>{
		this.setState({viewDetailPage:value})
	  }
    render() {
        const dropdownItem = ["Item 1", "Item 2", "Item 3"]
        const dataTable = [
            {
                HeaderItem: CATALOGUE_TABLE_HEADERS,
                dataItem: this.state.catalogueDataItem
            }
        ]
        const pages = {
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
        const listItem = [
            {
                listTitle: "Plan",
                href: "#"
            }
            , {
                listTitle: "Feature"
                , href: "#"
            }
            , {
                listTitle: "Rate"
                , href: "#"
            }
        ];
        return (
            <>
                <RequestHeaders headerTitle="Catalogue" />
                {this.state.viewDetailPage ? 
                    <CatalogueDetails closeForm={this.getData.bind(this)}/>
                    :
                    <div className="request-table data-table internal-data-table">
                        <HeaderFilter enableDropdown={true} dropdownItem={dropdownItem} enableExportExcel={true} btnAddTitle="Add" enableAddBtn={false} enableUploadBtn={true} listItem={listItem} haveTab={false} />
                        {dataTable.map((item, id) =>
                            <DataTable key={id} id={id} item={item} header={item.HeaderItem} data={item.dataItem} getData={this.getData} customClassName="table-container" isDataLoaded={true} pages={pages} paginationAction={this.updatePageNumber} havePagination={true} />
                        )}
                    </div>                                        
                }
               
            </>
        )
    }
}